import type { FetchArgs, FetchBaseQueryError } from "@reduxjs/toolkit/query";
import type { baseQueryWithReauth } from "shared/config/api/baseQueryWithReauth";
import type { Page } from "../model/types";

type FetchPage = (args: FetchArgs) => ReturnType<typeof baseQueryWithReauth>;

type AllPagesResult<P> = { data: P[] } | { error: FetchBaseQueryError };

const MAX_PER_PAGE = 50;
// Предохранитель от бесконечного цикла, если бэк вернёт неверный pages.
const MAX_PAGES = 20;

// Фильтры и сортировка табло — на клиенте, поэтому тянем все страницы.
export const fetchAllPages = async <P extends Page<unknown>>(
  fetchPage: FetchPage,
  { url, params }: Pick<FetchArgs, "url" | "params">,
): Promise<AllPagesResult<P>> => {
  const pages: P[] = [];
  for (let page = 1; page <= MAX_PAGES; page += 1) {
    const result = await fetchPage({
      url,
      params: { ...params, page, per_page: MAX_PER_PAGE },
    });
    if (result.error) return { error: result.error };
    const data = result.data as P;
    pages.push(data);
    if (page >= data.pages) break;
  }
  return { data: pages };
};
